// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-templates-story-page-tsx","600":"component---src-pages-header-demo-tsx","645":"component---src-pages-style-guide-tsx"}[chunkId] || chunkId) + "-" + {"245":"3b01a50d0c2123d78316","454":"0bfb58a9c8c196720b2e","600":"a927018dfff5bbad8763","645":"e5e4df908d8581d3c11b"}[chunkId] + ".js";
};